/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const CSMasterListItemStatus = createEnum('CS_MASTER_STATUS', {
  Active: 1,
  Inactive: 0,
});

export type CSMasterListItemStatus = EnumSet<typeof CSMasterListItemStatus>;

export type CSMasterListItemDto = WithOptimisticLock<{
  id: ID;
  officeId: ID;
  name: string;
  status: string;
  statusValue: CSMasterListItemStatus;
  version: number;
  etag?: string;
}>;

export type CsMasterFilterDto = {
  showDeleted?: boolean;
  searchString?: string;
  sourceOfficeId?: ID;
};

export type CSMasterCCDto = {
  costCenterId: ID;
  code: string;
  description?: string;
};

export type CSMasterItemDto = {
  csMasterItemId: ID;
  name: string;
  description: string;
  costCenters: CSMasterCCDto[];
};

export type CSMasterSubHeadingDto = {
  csMasterSubHeadingId: ID;
  items: CSMasterItemDto[];
  name: string;
};

export type CSMasterHeadingDto = {
  csMasterHeadingId: ID;
  name: string;
  isNewPage: boolean;
  subHeadings: CSMasterSubHeadingDto[];
};

export type CSMasterDetailsDto = WithVersion<{
  csMasterId?: ID;
  name: string;
  status?: number;
  headings: CSMasterHeadingDto[];
}>;
